import * as React from "react"
import { SvgMail04 } from "@digits-shared/components/SVGIcons/line/Mail04.svg"
import { SvgRefreshCw01 } from "@digits-shared/components/SVGIcons/line/RefreshCw01.svg"
import { DigitsButton } from "@digits-shared/DesignSystem/Button"
import fonts from "@digits-shared/themes/typography"
import { styled } from "styled-components"
import { Header } from "src/frontend/components/Shared/Glow/Header"
import { titleIconStyles } from "src/frontend/components/Shared/Glow/Icon"

const Body = styled.div`
  font-size: 12px;
`

const RefreshIcon = styled(SvgRefreshCw01)`
  height: 24px !important;
  width: 24px !important;
`

export const Email = styled.span`
  font-weight: ${fonts.weight.heavy};
`

const MailIcon = styled(SvgMail04)`
  ${titleIconStyles};
`

export const EmailNotification: React.FC<
  React.PropsWithChildren<
    {
      id?: string
      onClick?: () => void
      disabled?: boolean
      loading?: boolean
      buttonLabel?: string
    } & EmailHeaderProps
  >
> = ({ id, onClick, onBack, disabled, loading, title, children, buttonLabel }) => (
  <>
    <EmailHeader onBack={onBack} loading={loading} title={title} />
    <Body>{children}</Body>
    {onClick && (
      <DigitsButton
        $fullWidth
        id={id || "resend-email"}
        disabled={disabled || loading}
        loading={loading}
        onClick={onClick}
        $variant="secondary-dark"
        leftDecorator={<RefreshIcon />}
        label={buttonLabel || "Resend Email"}
        aria-label={buttonLabel || "Resend Email"}
      />
    )}
  </>
)

type EmailHeaderProps = {
  onBack?: () => void
  loading?: boolean
  title?: string
}

export const EmailHeader: React.FC<EmailHeaderProps> = ({ onBack, loading, title }) => (
  <Header onBack={onBack} disabled={loading} icon={<MailIcon />}>
    {title || "Please check your email!"}
  </Header>
)
